export const texts = {
    ru: {
        start:{
            text1:'Lion Launch',
            text2:'Закрытый круг участников экосистемы. Раунды, ранги льва и колесо бонусов.',
            text3:'Членство открывает закрытые раунды, ранги и эволюцию льва, колесо бонусов и реферальную программу.',
            text4:'Это оплата доступа к приложению, а не инвестиция.',
            cta:'Открыть в Telegram'
        },
        bonuses: {
            bonus: 'Проекты экосистемы',
            day: 'дней',
            hour: 'часов',
            minute: 'минут',
        },
        balance: {
            text1: 'Баланс',
            text2: 'лап'
        },
        button: {
            text1: 'Вступить в Lion Launch — 260 ⭐',
            text2: 'Мой лимит',
            text3: 'Пригласить друзей',
            text4: 'Крутить колесо',
            text5: 'Участвовать в закрытом раунде',
            hintGuest: 'Членство открывает закрытые раунды, ранги льва, колесо бонусов и реферальную программу',
            rank: 'Ранг'
        },
        menu: {
            home: 'Главная',
            friends: 'Друзья',
            profit: 'Прокачать',
            map: 'Путь льва'
        },
        header: {
            guest: 'Гость',
            pride: 'Мой львиный прайд',
            members: 'участника',
            membersMany: 'участников',
            rules: 'Правила'
        },
        politics: {
            text1: 'Политика конфиденциальности',
            text2: 'Пользовательское соглашение'
        },
        settings: {
            address: 'Адрес кошелька запрашивается при заявке на раунд',
            text: 'Уведомления о раундах',
            save: 'Сохранить',
            docs: 'Правила и документы',
            support: 'Поддержка',
            delete: 'Удалить аккаунт',
            deleteConfirm: 'Удалить аккаунт? Повторно вступить с этого Telegram нельзя.',
            addressRound: 'Адрес кошелька для получения токенов запрашивается в заявке на раунд, формат EVM (0x…)'
        },
        spend: {
            title: 'На что потратить лапы',
            intro: 'Лапы дают скидку или право доступа. Их нельзя купить, вывести или передать.',
            nft: 'NFT-статусы',
            current: 'Текущий статус',
            none: 'Пока без статуса. Порог считается по максимальному балансу лап.',
            nftHint: 'Статус не отзывается после списания лап и не передаётся.',
            openWheel: 'Открыть колесо',
            openLimit: 'Мой лимит'
        },
        referrals: {
            text1: 'Мой прайд',
            text2: 'Уровень',
            text3: 'Уровни реферальной программы',
            text4: 'участников — ',
            text4_1: 'лап',
            text5: 'Бонус приходит, когда приглашённый вступил и подписался на обязательные каналы. Все 20 подписок удваивают бонус: 20 лап на 1 уровне и по 10 лап на 2–5.',
            text6: 'Пригласить друзей',
            share: 'Lion Launch — закрытый круг ранних участников. Вступай в прайд, получай лапы и доступ к закрытым раундам проектов'
        },
        roadmap: {
            text1: 'Путь льва',
            here: 'вы здесь',
            next: 'До следующего ранга',
            hint: 'Опыт растёт за стаж, подписки и новых участников команды на всех 5 уровнях. Статус закрепляется навсегда.',
            steps: 'Вступил → 20 подписок → 10 друзей → ранги',
            invite: 'Расти быстрее — пригласить друзей'
        },
        profit: {
            text1: 'Мои подписки',
            text2: 'Бонус за команду',
            text3: 'лап',
            text4: 'Подписаться',
            text5: 'Проверить подписку',
            required: 'обязательный',
            optional: 'по желанию',
            paws: '+5 лап',
            hint: '5 лап за подписку · каждая подписка +5% к бонусу за команду · все 20 = x2'
        },
        notificate: {
            text1: 'Ссылка скопирована',
            text2: 'Сначала вступите в Lion Launch',
            text3: 'Адрес кошелька понадобится при заявке на раунд',
            text4: 'Недостаточно лап',
            text5: 'Ошибка проверки подписки.'
        },
        withdraw:{
            text1: 'Мой лимит',
            text2: 'Лимит фиксируется за 7 дней до окна подписки.',
            text3: 'Заявки на раунд',
            text4: 'Всего заявок —',
            text5: 'Ваши заявки:',
            text6: 'Объём',
            text7: 'Очередь',
            text8: 'Исполнено',
            text9: 'Ваш лимит',
            text10: 'токенов',
        },
        addBalance:{
            text1: 'Членство в Lion Launch',
            text2: '260 ★ Stars',
            text3: 'разовый платёж',
            text4: '★ Оплатить Telegram Stars',
            terms: 'Я принимаю Пользовательское соглашение и Политику конфиденциальности',
            note: 'Членство — это оплата доступа к приложению, а не инвестиция. Лапы за оплату не начисляются: их дают подписки и ваша команда.',
            perk1: 'Участие в закрытых раундах проектов экосистемы',
            perk2: 'Ранги и эволюция вашего льва',
            perk3: 'Колесо бонусов и лапы за активность',
            perk4: 'Реферальная программа на 5 уровней'
        },
        presale:{
            dateHint: 'Подготовка проекта может занять от нескольких месяцев до 1–2 лет. Сроки могут меняться.',
            open: 'Подать заявку',
            soon: 'Таймер запустится после завершения MVP',
            limit: 'Ваш лимит',
            queue: 'Ваша очередь',
            price: 'Цена раунда',
            window: 'Окно подписки',
            developer: 'О разработчике — alderwayne.group',
            risk: 'Проекты на ранних стадиях несут высокий риск. Участие — ваше самостоятельное решение.',
            stages: ['Идея', 'ТЗ', 'MVP', 'Юр. оформление', 'Раунд']
        },
        extras:{
            wheel: 'Колесо бонусов',
            wheelText: 'Крутите колесо и получайте лапы.',
            ranks: 'Ранги',
            ranksText: 'Повышайте ранг и открывайте новые возможности.',
            lion: 'Путь льва',
            lionText: 'Лев меняет облик вместе с вашим рангом.',
            current: 'Текущий ранг',
            next: 'Следующий ранг',
            reqStart: 'Стартовый ранг',
            reqActivation: 'Членство',
            reqChannels: 'Подписка на {n} каналов',
            reqCoins: '{n} лап',
            achieved: 'Получен'
        },
        wheel:{
            title: 'Колесо бонусов',
            cost: 'Дополнительный спин — 50 лап',
            freeAvailable: 'Бесплатный спин — за каждого нового друга',
            spin: 'Крутить · 50 лап',
            spinFree: 'Крутить бесплатно',
            spinning: 'Крутится...',
            needCoins: 'Недостаточно лап. Нужно 50.',
            extraSpin: 'бесплатный спин',
            error: 'Не удалось выполнить спин',
            odds: 'Шансы выигрыша',
            sectorsCount: '9 секторов',
            legal: 'Спин нельзя оплатить деньгами, звёздами или криптовалютой. Результат определяется на сервере, шансы фиксированные и опубликованы в правилах.',
            balance: 'Баланс',
            invite: 'Пригласить друзей',
            sectors: [
                'Ничего',
                'Возврат\n50',
                'Ничего',
                'Бесплатный\nспин',
                '100\nлап',
                'Ничего',
                'Бесплатный\nспин',
                '1 000\nлап',
                '10 000\nлап'
            ]
        },
        limit: {
            title: 'Мой лимит',
            intro: 'Сколько вы сможете купить в ближайшем закрытом раунде. Лимит фиксируется за 7 дней до окна подписки.',
            base: 'База участника',
            invites: 'Приглашённые',
            subs: 'Подписки',
            paws: 'Лапы',
            pawHint: '1 лапа = +1 к лимиту',
            your: 'Ваш лимит',
            tokens: 'единиц',
            units: 'единиц',
            how: 'Как увеличить лимит',
            hint: 'Оплата — по цене раунда, одинаковой для всех. При покупке списываются только лапы. Потолок — не более 1% объёма раунда.',
            apps: 'Мои заявки на раунд',
            frozen: 'Лимит зафиксирован по снимку за 7 дней до окна.',
            applyTitle: 'Заявка на раунд',
            volume: 'Объём заявки',
            wallet: 'Адрес кошелька 0x…',
            apply: 'Подать заявку',
            errors: {
                wallet_required: 'Нужен адрес кошелька в формате 0x…',
                limit_exceeded: 'Объём больше вашего лимита',
                already_applied: 'Заявка на этот раунд уже есть',
                round_closed: 'Окно подписки закрыто',
                membership_required: 'Сначала вступите в Lion Launch',
                generic: 'Не удалось подать заявку'
            }
        }
    },
    eng:{
        start:{
            text1:'Lion Launch',
            text2:'A closed circle of ecosystem members. Rounds, lion ranks and the bonus wheel.',
            text3:'Membership unlocks closed rounds, lion ranks, the bonus wheel and the referral program.',
            text4:'This is payment for app access, not an investment.',
            cta:'Open in Telegram'
        },
        bonuses:{
            bonus:'Ecosystem projects',
            day:'days',
            hour:'hours',
            minute:'minutes',
        },
        balance: {
            text1: 'Balance',
            text2: 'paws'
        },
        button:{
            text1:'Join Lion Launch — 260 ⭐',
            text2:'My limit',
            text3:'Invite friends',
            text4:'Spin the wheel',
            text5:'Join the closed round',
            hintGuest:'Membership unlocks closed rounds, lion ranks, the bonus wheel and the referral program',
            rank: 'Rank'
        },
        menu:{
            home:'Home',
            friends:'Friends',
            profit:'Boost',
            map:'Lion path'
        },
        header: {
            guest: 'Guest',
            pride: 'My Lion Pride',
            members: 'member',
            membersMany: 'members',
            rules: 'Rules'
        },
        politics:{
            text1:'Privacy policy',
            text2:'User agreement'
        },
        settings:{
            address:'Wallet address is requested when you apply for a round',
            text:'Round notifications',
            save:'Save',
            docs:'Rules and documents',
            support:'Support',
            delete:'Delete account',
            deleteConfirm: 'Delete the account? You cannot join again from this Telegram.',
            addressRound: 'A wallet address for receiving tokens is requested in the round application, EVM format (0x…)'
        },
        spend: {
            title: 'What paws are for',
            intro: 'Paws give a discount or an access right. They cannot be bought, withdrawn or transferred.',
            nft: 'NFT statuses',
            current: 'Current status',
            none: 'No status yet. The threshold uses your maximum paw balance.',
            nftHint: 'The status stays after paws are spent and cannot be transferred.',
            openWheel: 'Open the wheel',
            openLimit: 'My limit'
        },
        referrals:{
            text1:'My pride',
            text2:'Level',
            text3:'Referral program levels',
            text4:'members — ',
            text4_1:'paws',
            text5:'The bonus arrives after the invitee joins and subscribes to required channels. All 20 subscriptions double the bonus: 20 paws on level 1 and 10 paws on levels 2–5.',
            text6:'Invite friends',
            share: 'Lion Launch is a closed circle of early members. Join the pride, earn paws and get access to closed rounds'
        },
        roadmap:{
            text1:'Lion path',
            here: 'you are here',
            next: 'To the next rank',
            hint: 'XP grows with tenure, subscriptions and new team members on all 5 levels. Status stays forever.',
            steps: 'Joined → 20 subscriptions → 10 friends → ranks',
            invite: 'Grow faster — invite friends'
        },
        profit:{
            text1: 'My subscriptions',
            text2: 'Team bonus',
            text3: 'paws',
            text4: 'Subscribe',
            text5: 'Check subscription',
            required: 'required',
            optional: 'optional',
            paws: '+5 paws',
            hint: '5 paws per subscription · each one +5% to the team bonus · all 20 = x2'
        },
        notificate:{
            text1:'Link copied',
            text2: 'Join Lion Launch first',
            text3: 'A wallet address is needed when you apply for a round',
            text4: 'Not enough paws',
            text5: 'Error checking subscription.'
        },
        withdraw:{
            text1: 'My limit',
            text2: 'The limit is fixed 7 days before the subscription window.',
            text3: 'Round applications',
            text4: 'Total applications —',
            text5: 'Your applications:',
            text6: 'Volume',
            text7: 'Queue',
            text8: 'Filled',
            text9: 'Your limit',
            text10: 'tokens',
        },
        addBalance:{
            text1: 'Lion Launch membership',
            text2: '260 ★ Stars',
            text3: 'one-time payment',
            text4: '★ Pay with Telegram Stars',
            terms: 'I accept the User agreement and the Privacy policy',
            note: 'Membership is a payment for access to the app, not an investment. Paws are not granted for payment.',
            perk1: 'Closed rounds of ecosystem projects',
            perk2: 'Ranks and evolution of your lion',
            perk3: 'Bonus wheel and paws for activity',
            perk4: 'Five-level referral program'
        },
        presale:{
            dateHint: 'Preparing a project can take from several months to 1–2 years. Dates may change.',
            open: 'Apply',
            soon: 'The timer starts after MVP is complete',
            limit: 'Your limit',
            queue: 'Your queue',
            price: 'Round price',
            window: 'Subscription window',
            developer: 'About the developer — alderwayne.group',
            risk: 'Early-stage projects carry high risk. Taking part is your own decision.',
            stages: ['Idea', 'Spec', 'MVP', 'Legal', 'Round']
        },
        extras:{
            wheel: 'Bonus wheel',
            wheelText: 'Spin the wheel and get paws.',
            ranks: 'Ranks',
            ranksText: 'Raise your rank and unlock new options.',
            lion: 'Lion path',
            lionText: 'The lion changes look as your rank grows.',
            current: 'Current rank',
            next: 'Next rank',
            reqStart: 'Starting rank',
            reqActivation: 'Membership',
            reqChannels: 'Subscribe to {n} channels',
            reqCoins: '{n} paws',
            achieved: 'Unlocked'
        },
        wheel:{
            title: 'Bonus wheel',
            cost: 'Extra spin — 50 paws',
            freeAvailable: 'A free spin for every new friend',
            spin: 'Spin · 50 paws',
            spinFree: 'Spin for free',
            spinning: 'Spinning...',
            needCoins: 'Not enough paws. You need 50.',
            extraSpin: 'free spin',
            error: 'Could not spin the wheel',
            odds: 'Win chances',
            sectorsCount: '9 sectors',
            legal: 'A spin cannot be paid with money, Stars or crypto. The result is decided on the server. Chances are fixed and published in the rules.',
            balance: 'Balance',
            invite: 'Invite friends',
            sectors: [
                'Nothing',
                'Return\n50',
                'Nothing',
                'Free\nspin',
                '100\npaws',
                'Nothing',
                'Free\nspin',
                '1,000\npaws',
                '10,000\npaws'
            ]
        },
        limit: {
            title: 'My limit',
            intro: 'How much you can buy in the next closed round. The limit is fixed 7 days before the window.',
            base: 'Member base',
            invites: 'Invites',
            subs: 'Subscriptions',
            paws: 'Paws',
            pawHint: '1 paw = +1 to the limit',
            your: 'Your limit',
            tokens: 'units',
            units: 'units',
            how: 'How to grow the limit',
            hint: 'Payment is at the same round price for everyone. Only paws are spent on a purchase. Cap is 1% of the round volume.',
            apps: 'My round applications',
            frozen: 'The limit is fixed from the snapshot 7 days before the window.',
            applyTitle: 'Round application',
            volume: 'Application volume',
            wallet: 'Wallet address 0x…',
            apply: 'Apply',
            errors: {
                wallet_required: 'A wallet address in 0x… format is required',
                limit_exceeded: 'The volume is above your limit',
                already_applied: 'You already applied for this round',
                round_closed: 'The subscription window is closed',
                membership_required: 'Join Lion Launch first',
                generic: 'Could not submit the application'
            }
        }
    }
}
